import lscache from "lscache";

import {HOME_MATCH_PREFERENCES_MODAL_DISMISSED, PHONE_NUMBER_MODAL_DISMISSED} from "@pg-rp/navigation";

export const userDataModalDisplayStorage = {
    resetUserModalDisplay: () => {
        lscache.remove(HOME_MATCH_PREFERENCES_MODAL_DISMISSED);
        lscache.remove(PHONE_NUMBER_MODAL_DISMISSED);
    }
};
import lscache from "lscache";

import {HOME_MATCH_PREFERENCES_MODAL_DISMISSED, PHONE_NUMBER_MODAL_DISMISSED} from "@pg-rp/navigation";

export const userDataModalDisplayStorage = {
    resetUserModalDisplay: () => {
        lscache.remove(HOME_MATCH_PREFERENCES_MODAL_DISMISSED);
        lscache.remove(PHONE_NUMBER_MODAL_DISMISSED);
    }
};
